import React from 'react';
import group from '../Assets/Group.png'
import group1 from '../Assets/ILLUSTRATION 03  1.png'
import group2 from '../Assets/Group-1.png'
import group3 from '../Assets/Group-2.png'
import ball1 from '../Assets/Ellipse 19.png'
import ball2 from '../Assets/Ellipse 24.png'
import ball3 from '../Assets/Ellipse 12.png'
import vector from '../Assets/Vector.png'
import bigball from '../Assets/Ellipse 7.png'

export default function Cards() {
    return (
        <>
            <div className="CardsOuter">
                <div className="cardContentLeft">

                    <div className="cardContent">
                        <h1>Learn the ways in which you can benefit<br />
                            from a UAE/Offshore Company. Then get<br />
                            started on fulfilling your UAE dream.</h1>
                        <span>Claim a Free Quote</span>

                    </div>

                    <div className="card">
                        <img src={group1} alt="/" />
                        <h1>Bank Account Setup</h1>
                        <p>There are many banks in the United<br />
                            Arab Emirates [UAE]. Both locally<br />
                            owned and branches of<br />
                            multinational ones. Foreign banks<br />
                            adjust according to their parent s<br />
                            strategies and have changed local<br />
                            requirements overnight in the past.<br />
                            But we are here to help you.
                        </p>
                        <div className="cardSpan">
                            <h2>Learn more <img src={vector} alt="/" /></h2>

                        </div>
                    </div>

                    <div className="cardBall">
                        <img src={ball3} alt="/" />
                    </div>

                    <div className="card">
                        <img src={group3} alt="/" />
                        <h1>UAE Company Visas</h1>
                        <p>Your application for visas is critical<br />
                            especially if you intend to move to<br />
                            Dubai. This becomes even more<br />
                            urgent if your family will also move<br />
                            with you. All the paperwork is done<br />
                            on your behalf smoothly so that you<br />
                            may only focus on doing what<br />
                            matters most to you.
                        </p>
                        <div className="cardSpan">
                            <h2>Learn more <img src={vector} alt="/" /></h2>

                        </div>
                    </div>
                </div>

                {/* Right */}

                <div className="cardContentRight">

                    <div className="card">
                        <img src={group} alt="/" />
                        <h1>Advice & Guidance</h1>
                        <p>All activities in the UAE are licensed.<br />
                            Whether manufacturing, finance,<br />
                            trading, marketing, consultancy or<br />
                            restaurants. In some countries only<br />
                            manufacturing is licensed. In others<br />
                            there is a threshold below which<br />
                            business are encouraged. Get our<br />
                            insightfull guidance today.
                        </p>
                        <div className="cardSpan">
                            <h2>Learn more <img src={vector} alt="/" /></h2>

                        </div>
                    </div>

                    <div className="cardBalls">
                        <img src={ball1} alt="/" />
                        <img src={ball2} alt="/" />
                    </div>


                    <div className="cardLast">
                        <img src={group2} alt="/" />
                        <h1>Registration Document<br />
                            Perparation</h1>
                        <p>Several documents must be<br />
                            prepared to start the process of<br />
                            registering a new company in the<br />
                            United Arab Emirates. Be it a Dubai<br />
                            local company, a free zone one or an<br />
                            offshore entity. Your registered<br />
                            agent is dedicated to get this done<br />
                            for you for a seamless process.
                        </p>
                        <div className="cardSpan">
                            <h2>Learn more <img src={vector} alt="/" /></h2>

                        </div>
                    </div>

                    <div className="cardContentLast">
                        <h1>We have gathered a team of<br />
                            professionals to craft adequate<br />
                            services you can rely on for a friction<br />
                            free setup in UAE.
                        </h1>
                        <div className="cardLastContent">
                            <h2>More about our services</h2>
                            <img src={vector} alt="/" />
                        </div>

                    </div>

                </div>

            </div>
            <div className="Middle">
                <img src={bigball} alt="/" />

                <center>
                    <h1>
                        Most <span>popular affordable pricing</span> per<br />
                        jurisdictions are brought to you to<br />
                        kick off your adventure.
                    </h1>
                </center>

                <img src={ball3} alt="/" />
            </div>
        </>
    );
}